import React from 'react'
import DashboardContainer from '../../containers/dashboard/DashboardContainer'

const DashboardPage = () => {
  return <DashboardContainer/>
}

export default DashboardPage